// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"vx_a bhc_b bhc_ux"};